import * as React from 'react';
import styled from '@emotion/styled';
import { Switch } from '@mui/material';

const IOSSwitchStyle = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, size }) => {
  const width = size === 'small' ? 40 : 60;
  const height = size === 'small' ? 24 : 32;
  const thumbSize = size === 'small' ? 16 : 27;
  const translateX = size === 'small' ? '16px' : '28px';
  const padding = size === 'small' ? '4px' : '0px';
  const margin = size === 'small' ? '0px' : '2px';
  return {
    width,
    height,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding,
      margin,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${translateX})`,
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#007f00',
          opacity: 1,
          border: 0
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5
        }
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '10px solid #fff'
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.mode === 'light' ? theme.palette.grey[100] : '#aaaaaa'
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
      }
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: thumbSize,
      height: thumbSize
    },
    '& .MuiSwitch-track': {
      borderRadius: height / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#aaaaaa' : '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500
      })
    },
    '&.switchRed .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        transform: `translateX(${translateX})`,
        color: '#fff',
        '+ .MuiSwitch-track': {
          backgroundColor: '#e0e0e0',
          opacity: 1
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          backgroundColor: '#e0e0e0',
          opacity: 1
        }
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: '#e0e0e0',
        opacity: 1,
        cursor: 'not-allowed'
      }
    }
  };
});

export default IOSSwitchStyle;
// import * as React from 'react';
// import styled from '@emotion/styled';
// import { Switch } from '@mui/material';

// const IOSSwitchStyle = styled((props) => (
//   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
// ))(({ theme }) => ({
//   width: 60,
//   height: 32,
//   padding: 0,
//   // '&.MuiSwitch-sizeSmall': {
//   //   width: 40,
//   //   height: 24,
//   //   '.MuiSwitch-thumb': {
//   //     width: 16,
//   //     height: 16
//   //   },
//   //   '.MuiSwitch-track': {
//   //     borderRadius: '7px'
//   //   }
//   // },
//   '&.switchRed': {
//     '.MuiSwitch-switchBase': {
//       '&.Mui-checked': {
//         transform: 'translateX(28px)',
//         color: '#fff',
//         '+ .MuiSwitch-track': {
//           backgroundColor: '#e0e0e0',
//           opacity: 1
//         },
//         '&.Mui-disabled + .MuiSwitch-track': {
//           backgroundColor: '#e0e0e0',
//           opacity: 1
//         }
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         backgroundColor: '#e0e0e0',
//         opacity: 1,
//         cursor: 'not-allowed'
//       }
//     }
//   },
//   '& .MuiSwitch-switchBase': {
//     padding: 0,
//     margin: 2,
//     transitionDuration: '300ms',
//     '&.Mui-checked': {
//       transform: 'translateX(28px)',
//       color: '#fff',
//       '& + .MuiSwitch-track': {
//         backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#007f00',
//         opacity: 1,
//         border: 0
//       },
//       '&.Mui-disabled + .MuiSwitch-track': {
//         opacity: 0.5
//       }
//     },
//     '&.Mui-focusVisible .MuiSwitch-thumb': {
//       color: '#33cf4d',
//       border: '10px solid #fff'
//     },
//     '&.Mui-disabled .MuiSwitch-thumb': {
//       color: theme.palette.mode === 'light' ? theme.palette.grey[100] : '#aaaaaa'
//     },
//     '&.Mui-disabled + .MuiSwitch-track': {
//       opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
//     }
//   },
//   '& .MuiSwitch-thumb': {
//     boxSizing: 'border-box',
//     width: 27,
//     height: 27
//   },
//   '& .MuiSwitch-track': {
//     borderRadius: 32 / 2,
//     backgroundColor: theme.palette.mode === 'light' ? '#aaaaaa' : '#E9E9EA',
//     opacity: 1,
//     transition: theme.transitions.create(['background-color'], {
//       duration: 500
//     })
//   }
// }));

// export default IOSSwitchStyle;
